import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 'medium',
  backgroundColor: theme.palette.background.paper,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&.Mui-selected:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const commonTextFieldSx = {
  zIndex: 0,
  '& .MuiInputAdornment-root': {
    marginLeft: 0,
    marginRight: '-4px',
  },
  '& .MuiInputBase-input': {
    cursor: 'pointer',
  },
  '& .MuiSelect-icon': {
    display: 'none',
  },
};

export const getMenuItemSx = (selected: boolean) => ({
  backgroundColor: selected ? 'primary.main' : 'transparent',
  color: selected ? 'white' : 'inherit',
  '&:hover': {
    backgroundColor: selected ? 'primary.dark' : 'primary.main',
    color: 'white',
  },
  '&.Mui-selected': {
    backgroundColor: 'primary.main',
    color: 'white',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'primary.dark',
  },
});
